import { NgModule, Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'media-headliner',
    templateUrl: 'media-headliner.template.html',
    styleUrls: ['./media-headliner.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaHeadliner {
    @Input() config: MediaCellConfig;
    @Input() 
    get item():any {
        return this._item;
    }
    set item(val:any){
        if(val.obj_type.indexOf("Sponsor")!= -1)
        {
            val.logo = val.images.find((img:any) => { return img.name == "thumb_640x"}).url;
        }

        this._item = val;
    }

    get copyEnabled():boolean {
        return this.settings && this.settings.showCopy && this.item && (this.item.meta || this.item).summary
    }

    private _item:any;
    private style: string;
    private settings: any = {
        clickEnable: true
    };

    private get disabled() {
        return !this.settings.clickEnable;
    }

    ngOnInit() {
        Object.assign(this.settings, this.config);
        this.setCellStyle();
    }

    private setCellStyle() {
        switch (this.settings.size) {
            case "lg":
                this.style = "col-md-6 col-lg-6"
                break;
            case "sm":
                this.style = "col-md-6 col-lg-3"
                break;
            case "md":
            default:
                this.style = "col-md-6 col-lg-4"
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/media-cell/media-headliner/media-headliner.component.ts